export interface SwapMint {
  id: string
  name: string
  symbol: string
  decimals: number
  displayDecimals?: number | null
  address?: string
  chain: string
  image?: string
}

export interface SwapData {
  id: string
  companyId: string
  company: string
  group: string
  requestedById?: string
  requestedBy?: string
  decisionById?: string
  decisionBy?: string
  fromMint: SwapMint
  toMint: SwapMint
  fromAmount: string
  toAmount: string
  lpFee: string
  groupBps: number
  swapGroupBps: number
  swapLpBps: number
  swapValiantBps: number
  lpId: number
  usdValue?: string
  status: string
  lpReference?: string
  lpWithdrawalTxHash?: string
  pushoutWithdrawalTxHash?: string
  createdAt: string
  updatedAt: string
  decisionAt?: string
  completedAt?: string
  whitelistedAddress?: string
  isFlagged: boolean
  isExternalApi?: boolean | null
}

export enum SwapStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  PushOutCompleted = 'PUSH_OUT_COMPLETED',
  PushOutFailed = 'PUSH_OUT_FAILED',
  PushOutInitiated = 'PUSH_OUT_INITIATED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  TradeCompleted = 'TRADE_COMPLETED',
  TradeExecuting = 'TRADE_EXECUTING',
  TradeFailed = 'TRADE_FAILED',
  WithdrawalCompleted = 'WITHDRAWAL_COMPLETED',
  WithdrawalFailed = 'WITHDRAWAL_FAILED',
  WithdrawalInitiated = 'WITHDRAWAL_INITIATED',
}
